import { Injectable } from '@angular/core';
// import {
//   AppleSignInResponse,
//   ASAuthorizationAppleIDRequest,
//   SignInWithApple,
// } from '@awesome-cordova-plugins/sign-in-with-apple/ngx';
import { Platform } from '@ionic/angular';
//import firebase from 'firebase/app';
import 'firebase/auth';
import { BoxxOAuthTemplateMethod } from '../classes/OAuthTemplateMethod';
import { AppleOAuthResponse } from '../contracts/IAppleOAuthResponse';

@Injectable({
  providedIn: 'root', //<-- in order to be a singleton
})
export class BoxxAppleOAuthService extends BoxxOAuthTemplateMethod {
  //private readonly provider = new firebase.auth.OAuthProvider('apple.com');

  constructor(
    platform: Platform, 
    //private signInWithApple: SignInWithApple
  ) {
    super(platform);
  }

  getProvider() {
    //return this.provider;
  }

  async webOAuth(): Promise<AppleOAuthResponse> {
    try {
      return null;
      // this.provider.addScope('email');
      // this.provider.addScope('name');

      // const oauthResp = await firebase.auth().signInWithPopup(this.provider);

      // const credential: firebase.auth.OAuthCredential = oauthResp.credential;

      // // The signed-in user info.
      // const user = oauthResp.user;

      // const response: AppleOAuthResponse = {
      //   authResponse: {
      //     accessToken: credential.accessToken,
      //     idToken: credential.idToken,
      //     refreshToken: user.refreshToken,
      //   },
      //   profileResponse: {
      //     email: user.email,
      //     firstName: user.displayName,
      //     lastName: '',
      //     imageUrl: user.photoURL,
      //   },
      // };

      // return response;
    } catch (e) {
      console.error('webOAuth() error', e);
      this.manageOAuthError(e);
    }
  }

  // this will only work on real Apple device (required os >= 13) or
  // in simulator wit os < 14
  // see: https://developer.apple.com/forums/thread/651533?page=3
  async nativeOAuth(config?: any): Promise<AppleOAuthResponse> {
    try {
      return null;
      // const res: AppleSignInResponse = await this.signInWithApple.signin({
      //   requestedScopes: [
      //     ASAuthorizationAppleIDRequest.ASAuthorizationScopeFullName,
      //     ASAuthorizationAppleIDRequest.ASAuthorizationScopeEmail,
      //   ],
      // });
      // // https://developer.apple.com/documentation/signinwithapplerestapi/verifying_a_user
      // var provider = new firebase.auth.OAuthProvider('apple.com');

      // const authCredential = provider.credential({
      //   idToken: res.identityToken,
      //   rawNonce: new Date().getTime().toString(),
      // });

      // try {
      //   const result = await firebase.auth().signInWithCredential(authCredential);

      //   const response: AppleOAuthResponse = {
      //     authResponse: {
      //       accessToken: null,
      //       idToken: (result.credential as any).oauthIdToken,
      //       refreshToken: null,
      //     },
      //     profileResponse: {
      //       email: result.user.email,
      //       firstName: result.user.displayName,
      //       lastName: null,
      //       imageUrl: result.user.photoURL,
      //     },
      //   };
      //   return response;
      // } catch (error) {
      //   // An error occurred. If error.code == 'auth/missing-or-invalid-nonce',
      //   // make sure you're sending the SHA256-hashed nonce as a hex string
      //   // with your request to Apple.
      //   console.error('signInWithCredential error', error);
      //   this.manageOAuthError(error);
      // }
    } catch (error) {
      console.error('nativeOAuth()', error.code + ' ' + error.localizedDescription);
      this.manageOAuthError(error);
    }
  }
}
